type SectionTitleProps = {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
};

export default function SectionTitle({
  eyebrow,
  title,
  desc,
  align = "left",
}: SectionTitleProps) {
  const isCenter = align === "center";
  return (
    <div className={`${isCenter ? "text-center mx-auto max-w-2xl" : "max-w-2xl"}`}>
      {eyebrow && (
        <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100 text-accent-900 text-xs font-bold tracking-wide">
          <i className="ri-sparkling-2-fill"></i>
          {eyebrow}
        </span>
      )}
      <h2 className="mt-3 text-2xl md:text-3xl font-black text-foreground-950 font-heading">
        {title}
      </h2>
      {desc && (
        <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">
          {desc}
        </p>
      )}
    </div>
  );
}